import { useCallback, useMemo, useState } from 'react'
import { ResourceType } from '@ds-frontend/resource'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import RMasonry from 'react-masonry-css'

import ExperienceMasonryItem from './ExperienceMasonryItem'
import API from 'api'
import { useTranslations } from 'common/language'
import { BlockSectionTitle, BlockWrapper, Button, Container, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ExperienceMasonry.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    kind: PropTypes.string.isRequired,
    parent_id: PropTypes.string.isRequired,
  }).isRequired,
  getExperiences: ResourceType.isRequired,
  withoutCTA: PropTypes.bool,
}

const breakpointColumnsObj = {
  default: 3,
  1024: 2,
  576: 1,
}

export default function ExperienceMasonry({
  data,
  getExperiences,
  withoutCTA = false,
}) {
  const { gettext } = useTranslations()
  const [experiences, setExperiences] = useState(get(getExperiences, 'data.results', []))
  const isMoreEnabled = useMemo(() => experiences.length < get(getExperiences, 'data.count'), [experiences, getExperiences?.data])
  const [offset, setOffset] = useState(3)
  const [loading, setLoading] = useState(false)
  const items = useMemo(
    () =>
      experiences.map((option, index) => (
        <ExperienceMasonryItem
          key={index}
          cta={gettext('View Language School')}
          {...option}
          school_url={withoutCTA ? null : option.school_url}
        />
      )),
    [experiences],
  )
  const getAdditionalExperiences = useCallback(() => {
    setLoading(true)
    API.get('api/v1/feefo/experiences', { params: { kind: data.kind, parent_id: data.parent_id, offset: offset, limit: 3 } })
      .then(res => {
        setOffset(offset => offset + 3)
        setExperiences(exp => exp.concat(res.results))
      })
      .finally(_ => setLoading(false))
  }, [data.kind, data.parent_id, offset])
  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        {getExperiences?.data?.count !== 0
          ? (<RMasonry
            breakpointCols={breakpointColumnsObj}
            className={classNames.container}
            columnClassName={classNames.column}
          >
            {items}
          </RMasonry>)
          : (
            <Typography
              variant="h4"
              align="center"
              className={classNames.emptyText}
            >
              {gettext('There is no snapshot available yet.')}
            </Typography>
          )}
        {isMoreEnabled && (
          <div className={classNames.showMore}>
            <Button
              onClick={getAdditionalExperiences}
              className={classNames.button}
              isLoading={loading}
            >
              {gettext('more')}
            </Button>
          </div>)}
      </Container>
    </BlockWrapper>
  )
}
